// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"23904349","193":"370708a5"}[chunkId] + ".chunk.js";
};